module.exports = __webpack_public_path__ + "img/lens-150-minus-09.c53f84fc.png";